<template>

    <div class="box box-solid">
        <div class="box-header">
            <h2 class="box-title" v-text="boxTitle"></h2>
        </div>
        <div class="box-body">
            <div :class="{'form-group':true,'has-error':errors.has('name')}">
                <label for="name">Gebruikersgroep naam:</label>
                <input
                    type="text"
                    id="name"
                    class="form-control"
                    maxlength="191"
                    v-model="form.name"
                />
                <span class="help-block" v-if="errors.has('name')">{{ errors.get('name') }}</span>
            </div>
            <div class="form-group">
                <label for="rate">Uurtarief:</label>
                <money
                    id="rate"
                    v-model="form.rate"
                    v-bind="money"
                    class="form-control"
                ></money>
                <span class="help-block">Wanneer het uurtarief aangepast wordt, zal deze alleen over toekomstige uren berekend worden. Uren die reeds geregistreerd zijn worden berekend met het oude tarief.</span>
            </div>
            <div class="form-group">
                <label for="active">Productiviteitspercentage:</label>
                <div class="input-group">
                    <input
                        id="active"
                        type="number"
                        class="form-control"
                        v-model="form.active"
                    />
                    <span class="input-group-addon">
                        %
                    </span>
                </div>
            </div>

            <yes-no-radio
                v-model="form.partnergroup"
                label="Partner groep"
                description="Er kan maar &eacute;&eacute;n partner groep tegelijkertijd zijn. Wanneer deze groep wordt ingesteld als partnergroep, zal de oude automatisch gedeactiveerd worden als partner groep."
            ></yes-no-radio>

            <div class="form-group text-right">
                <button
                    class="btn btn-primary"
                    :disabled="!canSubmit"
                    @click="onSubmit"
                >{{ edit === true ? 'Wijzigen' : 'Toevoegen' }}</button>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import {Money} from 'v-money';
import Errors from "../../../Errors";
import YesNoRadio from "../../Common/Form/YesNoRadio";

export default {

    components: {
        Money,
        YesNoRadio,
    },

    computed: {
        canSubmit() {
            return this.loading === false &&
                this.form.name !== '';
        },

        getPostdata() {
            return this.form;
        },

        getRoute() {
            return this.edit === true ?
                this.route('api.v1.hr.usergroups.update', {uuid: this.usergroup.uuid}) :
                this.route('api.v1.hr.usergroups.store');
        },
    },

    data() {
        return {
            edit:false,
            errors:new Errors,
            form: {
                name:'',
                active:0,
                rate:0,
                partnergroup:false,
            },
            loading:false,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '€ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    methods: {
        getUsergroupData() {
            this.loading = true;
            axios.get(this.route('api.v1.hr.usergroups.show', {uuid: this.usergroup.uuid}))
            .then(resp => {
                this.form = resp.data;
                this.loading = false;
                this.edit = true;
            })
        },

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }
            this.loading = true;
            axios.post(this.getRoute, this.getPostdata)
                .then(resp => {
                    if (resp.data.success) {
                        this.$snotify.success(this.editing === true ? 'De gebruikersgroep is aangepast' : 'De gebruikersgroep is toegevoegd');
                        this.$emit('updateUsergroups');
                        this.$router.push({
                            name:'hr.usergroups.show',
                            params: {
                                uuid: resp.data.data.usergroup_uuid,
                            }
                        });
                    } else {
                        this.$snotify.error('Er is een fout opgetreden bij het ' + (this.editing ? 'aanpassen' : 'toevoegen') + ' van de gebruikersgroep.');
                    }
                })
                .catch(err => {
                    this.errors.record(err.response.data.errors);
                    this.$snotify.error('Er zijn fouten gevonden in het formulier');
                });
        }
    },

    mounted() {
        if (this.usergroup) {
            this.getUsergroupData();
        }
    },

    name:'HrUsergroupForm',

    props: {
        boxTitle: {
            required:true,
            type:String,
        },
        usergroup: {
            type:Number,
        },
    },

}

</script>
